import { observer } from 'mobx-react';
import React from 'react';
import { TvPackageOfferingCarousel, TvPackageOfferingCarouselProps } from '@teliaee/telia-common-components';
import config from '../Config';
import { useStores } from '../stores/RootStore';
import { CUSTOMER_TYPE_PRIVATE } from '../stores/SsoStore';

export const TvPackageOfferingCarouselContainer = observer((props: TvPackageOfferingCarouselProps) => {
  const { languageStore, ssoStore } = useStores();

  return (
    <TvPackageOfferingCarousel
      tier={config.componentTier}
      app={'public'}
      language={languageStore.currentLanguage}
      disableTranslationsStatistics={props.disableTranslationsStatistics}
      isTestEnvironment={props.isTestEnvironment}
      headingLevel={props.headingLevel}
      packageData={props.packageData}
      generateBasketId={ssoStore.customerType === CUSTOMER_TYPE_PRIVATE}
      customerId={ssoStore.customerId}
    />
  );
});
